var path = '/pages/vouchers/main/views/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vouchers/main/views/list.tpl.html
// module id = 2329
// module chunks = 1